import { render, staticRenderFns } from "./formdialogsp.vue?vue&type=template&id=c19f3a7e&scoped=true"
import script from "./formdialogsp.vue?vue&type=script&lang=js"
export * from "./formdialogsp.vue?vue&type=script&lang=js"
import style0 from "./formdialogsp.vue?vue&type=style&index=0&id=c19f3a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19f3a7e",
  null
  
)

export default component.exports